import EntityFinderTabBase from "./EntityFinderTabBase.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";

export default class EntityFinderChecklistTab extends EntityFinderTabBase {

  static get $name() {
    return "EntityFinderChecklistTab";
  }

  static get type() {
    return "entityfinderchecklisttab";
  }

  static get configurable() {
    return super.getTabWidget("Checklists", {type: WIDGET_KEYS.columnEntityMainName, text: "Checklists", field: 'title'})
  }

  onOpenEntityEditor({ record }) {
    this.editorHandler.openEditor(EDITOR_KEYS.checklistItemEditor, record, { checklist: record });
  }

  get storeKey() {
    return STORE_KEYS.checklistStore;
  }

  loadRecord(record, context, otherParams) {
    if (!otherParams.isOnlyFinder) {
      this.disabled = true;
    } else {
      this.disabled = false;
      super.loadRecord(record, context, otherParams);
    }
  }
}

EntityFinderChecklistTab.initClass();